const configAmplify = {
    s3: {
        REGION: import.meta.env.VITE_AWS_REGION,
        BUCKET: "YOUR_S3_UPLOADS_BUCKET_NAME"
    },
    apiGateway: {
        REGION: import.meta.env.VITE_AWS_REGION,
        URL: import.meta.env.VITE_API_ADDRESS
    },
    cognito: {
        REGION: import.meta.env.VITE_AWS_REGION,
        USER_POOL_ID: import.meta.env.VITE_COGNITO_USER_POOL_ID,
        APP_CLIENT_ID: import.meta.env.VITE_COGNITO_APP_CLIENT_ID,
        IDENTITY_POOL_ID: import.meta.env.VITE_COGNITO_IDENTITY_POOL_ID
    }
};

export default configAmplify;
